import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CalendarFollowUp from './icon-calendar-follow-up.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CalendarFollowUp {...validProps} />;
}
SvgComponent.iconName = 'calendarFollowUp';

/**
 * @deprecated This is a legacy icon
 */
export const CalendarFollowUpIcon = svgIconWrapper(SvgComponent);
